import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel, FieldDescription } from '@/components/ui/field';
import { useTranslation } from 'react-i18next';

export const FORM_USER_EMAIL_EDIT_ID = 'form-user-email-edit';

const initialState = {
    email: '',
    password: '',
};

export default function FormUserEmailEdit({ user, onSubmit, onReset }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState(initialState);

    useEffect(() => {
        setFormData({
            email: user?.email ?? '',
            password: '',
        });
    }, [user]);

    useEffect(() => {
        if (onReset) {
            setFormData({
                email: user?.email ?? '',
                password: '',
            });
        }
    }, [onReset, user]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.email?.trim() || !formData.password?.trim()) return;
        onSubmit({ email: formData.email.trim(), password: formData.password });
    };

    return (
        <form
            id={FORM_USER_EMAIL_EDIT_ID}
            onSubmit={handleSubmit}
            className="flex-1 overflow-y-auto px-6 py-4 space-y-5"
        >
            <Field>
                <FieldLabel required>{t('account:nouvelEmail')}</FieldLabel>
                <Input
                    type="email"
                    placeholder={t('account:exJeanDupontExempleCom')}
                    value={formData.email}
                    onChange={(e) => setFormData((p) => ({ ...p, email: e.target.value }))}
                    required
                />
            </Field>

            <Field>
                <FieldLabel required>{t('account:motDePasseActuel')}</FieldLabel>
                <Input
                    type="password"
                    placeholder={t('account:votreMotDePasse')}
                    value={formData.password}
                    onChange={(e) => setFormData((p) => ({ ...p, password: e.target.value }))}
                    required
                />
            </Field>

            <FieldDescription className="text-[13px] text-muted-foreground">
                {t('account:pourDesRaisonsDeSecuriteLEmailNecessite')}
            </FieldDescription>
        </form>
    );
}
